import cn from 'classnames';
import Icon from 'components/shared/icon';
import { useState } from 'react';
import RichText from 'components/shared/richtext';
import { formatPriceByStoreLocale } from 'lib/shopify';
import styles from '../salonAccount.module.scss';

const Modal = ({
  modalOpen,
  handleModal,
  handleRequestPayout,
  payoutError,
  fees,
  global,
  locale,
}) => {
  const fee = parseFloat(fees.payable);
  const [requested, setRequested] = useState(false);
  const [loading, setLoading] = useState(false);
  const minimumPayout = parseFloat(global.account['salonAccount-MinimumPayout']?.text || 25);
  const {
    amountLabel,
    closeButtonText,
    errorMessage,
    info,
    notEnoughFeeMessage,
    noFeeMessage,
    submitButtonText,
    subtitle,
    title,
    subtitleRequested,
  } = global.payoutPopup || {};

  const handleSubmit = async () => {
    setLoading(true);
    await handleRequestPayout();

    if (payoutError) {
      setLoading(false);
      return false;
    }
    setLoading(false);
    setRequested(true);
    return true;
  };

  return (
    <div className={cn(styles.modal, { [styles.active]: modalOpen })}>
      <div className={cn(styles.overlay, { [styles.on]: modalOpen })} />
      <div className={cn(styles.content, { [styles.open]: modalOpen })}>
        <div
          className={styles.close}
          onClick={handleModal}
          onKeyDown={handleModal}
          role="button"
          tabIndex="0"
        >
          <Icon type="close" />
        </div>
        <h1 className={styles.header}>{title?.text}</h1>
        <p className={styles.subtitle}>{requested ? subtitleRequested?.text : subtitle?.text}</p>
        {requested && (
          <div
            className={styles.button}
            onClick={handleModal}
            onKeyDown={handleModal}
            role="button"
            tabIndex="0"
          >
            {closeButtonText.text}
          </div>
        )}
        {!requested && fee > 0 && fee > minimumPayout && (
          <>
            <div className={styles.paymentDetails}>
              <div className={styles.label}>{amountLabel?.text}</div>
              <div className={styles.amount}>
                {formatPriceByStoreLocale({
                  locale,
                  price: fee,
                })}
              </div>
            </div>
            <RichText text={info?.text?.json} className={styles.info} />
            {loading ? (
              <div className={styles.loadingButton}>
                <Icon type="loading" />
              </div>
            ) : (
              <div
                className={styles.button}
                onClick={handleSubmit}
                onKeyDown={handleSubmit}
                role="button"
                tabIndex="0"
              >
                {submitButtonText?.text}
              </div>
            )}
          </>
        )}
        {!requested && fee <= 0 && (
          <div className={styles.info}>
            <Icon type="warning" className={styles.icon} />
            {noFeeMessage?.text}
          </div>
        )}
        {!requested && fee > 0 && fee < minimumPayout && (
          <div className={styles.info}>
            <Icon type="warning" className={styles.icon} />
            {notEnoughFeeMessage.text
              .replace(
                '{minimumPayout}',
                formatPriceByStoreLocale({ locale, price: minimumPayout })
              )
              .replace('{fee}', formatPriceByStoreLocale({ locale, price: fee }))}
          </div>
        )}
        {payoutError && (
          <div className={styles.info}>
            <Icon type="warning" className={styles.iconDanger} />
            <RichText text={errorMessage?.text?.json} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
